<template>
    <teleport to="body">
        <transition name="mdrawer">
            <div v-if="modelValue" class="mdrawer-root" @keydown.esc="close">
                <div class="mdrawer-backdrop" @click="close"></div>
                <aside class="mdrawer" :style="{ width: width }" role="dialog" aria-modal="true">
                    <header class="mdrawer__head">
                        <h3 class="mdrawer__title">{{ title }}</h3>
                        <div class="mdrawer__head-actions">
                            <slot name="header-actions"></slot>
                            <button type="button" class="mdrawer__close" @click="close" aria-label="Kapat"><i class="ki-filled ki-cross"></i></button>
                        </div>
                    </header>
                    <div class="mdrawer__body">
                        <slot></slot>
                    </div>
                    <footer v-if="$slots.footer" class="mdrawer__foot">
                        <slot name="footer"></slot>
                    </footer>
                </aside>
            </div>
        </transition>
    </teleport>
</template>

<script>
export default {
    name: 'MDrawer',
    props: {
        modelValue: { type: Boolean, default: false },
        title: { type: String, default: '' },
        width: { type: String, default: '520px' },
    },
    emits: ['update:modelValue', 'close'],
    watch: {
        modelValue(v) {
            document.body.style.overflow = v ? 'hidden' : ''
        },
    },
    beforeUnmount() { document.body.style.overflow = '' },
    methods: {
        close() { this.$emit('update:modelValue', false); this.$emit('close') },
    },
}
</script>

<style scoped>
.mdrawer-root { position: fixed; inset: 0; z-index: 3000; }
.mdrawer-backdrop { position: absolute; inset: 0; background: rgba(10, 15, 30, .35); }
.mdrawer {
    position: absolute; top: 0; right: 0; bottom: 0; max-width: 96vw;
    background: #fff; box-shadow: -8px 0 32px rgba(10, 15, 30, .18);
    display: flex; flex-direction: column;
}
.mdrawer__head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 1rem 1.25rem; border-bottom: 1px solid var(--tw-border, #E5E8EC); flex-shrink: 0;
}
.mdrawer__title { font-size: 1.05rem; font-weight: 700; margin: 0; }
.mdrawer__head-actions { display: flex; align-items: center; gap: .5rem; }
.mdrawer__close {
    background: transparent; border: 0; cursor: pointer; color: var(--tw-muted-foreground, #64748b);
    width: 2rem; height: 2rem; border-radius: 8px; display: flex; align-items: center; justify-content: center;
}
.mdrawer__close:hover { background: var(--tw-muted, #f1f5f9); color: var(--tw-mono, #0A0F1E); }
.mdrawer__body { flex: 1; overflow-y: auto; padding: 1.25rem; }
.mdrawer__foot {
    display: flex; align-items: center; justify-content: flex-end; gap: .6rem;
    padding: 1rem 1.25rem; border-top: 1px solid var(--tw-border, #E5E8EC); flex-shrink: 0; background: #fff;
}
/* geçiş */
.mdrawer-enter-active .mdrawer, .mdrawer-leave-active .mdrawer { transition: transform .22s ease; }
.mdrawer-enter-from .mdrawer, .mdrawer-leave-to .mdrawer { transform: translateX(100%); }
.mdrawer-enter-active .mdrawer-backdrop, .mdrawer-leave-active .mdrawer-backdrop { transition: opacity .22s ease; }
.mdrawer-enter-from .mdrawer-backdrop, .mdrawer-leave-to .mdrawer-backdrop { opacity: 0; }
</style>
